import type { iProfitAllocationRecord } from "@sdk/profit-allocation-records/profit-allocation-record-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { profitAllocationRecordsDefaultQueryConfig } from "./profit-allocation-records-default-query";

export const {
  slice: ProfitAllocationRecordsSlice,
  reducers: ProfitAllocationRecordsSliceReducer,
  actions: {
    setEntityQueryResults: setProfitAllocationRecordsQueryResults,
    setEntity: setProfitAllocationRecord,
    setEntities: setProfitAllocationRecords,
    patchEntity: patchProfitAllocationRecord,
    addNewEntity: addNewProfitAllocationRecord,
    setEntityFetchingStatus: setProfitAllocationRecordFetchingStatus,
    setEntitiesFetchingStatus: setProfitAllocationRecordsFetchingStatus,
    setEntityFailedStatus: setProfitAllocationRecordFailedStatus,
    setEntityQueryError: setProfitAllocationRecordsQueryError,
    resetQuery: resetProfitAllocationRecordsQuery,
    setQueryList: setProfitAllocationRecordQueryList,
  },
} = CreateEntitySlice<iProfitAllocationRecord>({
  sliceName: "profitAllocationRecords",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...profitAllocationRecordsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
